import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import tarifShiftService from "../../../services/ref/tarifShiftService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tarif_shift: false,
    data_tarif_shift: [],
    data_import: [],
    showMessage:false,
    message:'',
}

export const getDataTarifShift = createAsyncThunk('tarif_shift/data',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifShiftService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
    }
})

export const getaDataImport = createAsyncThunk('tarif_shift/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifShiftService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('tarif_shift/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifShiftService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('tarif_shift/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tarifShiftService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const tarifShiftSlice = createSlice({
    name: 'tarif_shift',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tarif_shift = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTarifShift.fulfilled, (state, action) => {
                state.loading_tarif_shift = false
                state.data_tarif_shift = action.payload??[]
            })
            .addCase(getDataTarifShift.pending, (state) => {
                state.loading_tarif_shift = true
            })
            .addCase(getDataTarifShift.rejected, (state, action) => {
                state.loading_tarif_shift = false
                state.data_tarif_shift = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_tarif_shift = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_tarif_shift = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_tarif_shift = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = tarifShiftSlice.actions

export default tarifShiftSlice.reducer
